<template>
    <div>
        <f-title :title="$t('contract.termsOfCancelation') " v-if="showTitle" />
        <v-row class="no-frame"  >
            <v-col class="no-frame col-4 pr-2" v-show="monthsNeeded">
                <v-text-field
                    :label         = "$t('contract.toc.months')"
                    v-model        = "contract.tocMonths"
                    :rules         = "[ monthRule ]"
                    :readonly      = "readonly"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    type         = "number"
                />
            </v-col>
            <v-col class="no-frame" :class="monthsNeeded ? 'pl-2' : ''">
                <f-enum-select
                    v-model   = "contract.tocType"
                    :label    = "$t('contract.toc.until')"
                    :rules    = "[ tocTypeRule ]"
                    :readonly = "readonly"
                    module    = "msd"
                    type      = "contractTocType"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame"  >
            <v-textarea
                class          = "pt-0"
                v-model        = "contract.tocComment"
                rows           = "3"
                :readonly      = "readonly"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                no-resize
                hide-details
            />
        </v-row>
        <v-row class="no-frame"  >
            <v-col class="no-frame col-6">
                <v-checkbox
                    v-model   = "contract.tocRewal"
                    :label    = "$t('contract.toc.renewal.automatic')"
                    :ripple   = "false"
                    :readonly = "readonly"
                    style     = "margin-top:16px"
                    hide-details
                />
            </v-col>
            <v-col class="no-frame col-2 pr-2">
                <v-text-field
                    v-show="contract.tocRewal"
                    v-model        = "contract.tocRenewalDuration"
                    :label         = "$t('contract.toc.renewal.duration')"
                    :readonly      = "readonly"
                    :rules         = "[ renewalRule ]"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    type           = "number"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-enum-select
                    v-show="contract.tocRewal"
                    v-model   = "contract.renewalType"
                    :label    = "$t('contract.toc.renewal.period')"
                    :rules    = "[ renewalTypeRule ]"
                    :readonly = "readonly"
                    module    = "msd"
                    type      = "contractRenewalType"
                />
            </v-col>
        </v-row>
        <!--
        <v-row class="no-frame" v-show="contract.tocRewal">
            <v-col class="no-frame col-4 pr-2">
                <v-text-field
                    v-model        = "contract.tocRenewalDuration"
                    :label         = "$t('contract.toc.renewal.duration')"
                    :readonly      = "readonly"
                    :rules         = "[ renewalRule ]"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    type           = "number"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-enum-select
                    v-model   = "contract.renewalType"
                    :label    = "$t('contract.toc.renewal.period')"
                    :rules    = "[ renewalTypeRule ]"
                    :readonly = "readonly"
                    module    = "msd"
                    type      = "contractRenewalType"
                />
            </v-col>
        </v-row>
        -->
    </div>
</template>

<script>

import Core        from "@/modules/core/service/Core";
import Contract    from "@/modules/msd/company/contract/service/Contract";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";
import FTitle      from "@/modules/core/components/utils/FTitle";

export default {
    name: "CContractToc",
    components: {
        FTitle,
        FEnumSelect,
    },

    props: {
        contract: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    tocType           : null,
                    tocMonths         : null,
                    tocRewal          : null,
                    tocComment        : null,
                    tocRenewalDuration: null,
                    renewalType       : null
                }
            },
        },


        showTitle: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    computed: {
        monthsNeeded () {
            if (!this.contract.tocType) {
                return true;
            }

            return this.contract.tocType.id !== Contract.enums.toc.mounths
                && this.contract.tocType.id !== Contract.enums.toc.fix
                && this.contract.tocType.id !== Contract.enums.toc.special
                && this.contract.tocType.id !== 0
   //             && this.contract.tocType.id !== Contract.enums.toc.contractend;
        },

        requiredRule() {
            return Core.rule.required;
        },
    },

    methods: {
        monthRule (value) {
            if (!this.monthsNeeded) {
                return true;
            }

            if (!value || value.length === 0) {
                return this.$t("rules.required");
            }

            if (this.contract.tocType) {
                switch (this.contract.tocType.id) {
                    case Contract.enums.toc.quarters:
                        if (value < 1 || value > 3) {
                            return this.$t('contract.toc.max3');
                        }
                        break;
                    case Contract.enums.toc.halfyears:
                        if (value < 1 || value > 6) {
                            return this.$t('contract.toc.max6');
                        }
                        break;
                    case Contract.enums.toc.years:
                        if (value < 1 || value > 12) {
                            return this.$t('contract.toc.max12');
                        }
                        break;
                }
            }

            return true;
        },

        tocTypeRule (value) {
            if (!value) {
                return this.$t("rules.required");
            }

            if (this.contract.tocMonths > 0 && !value) {
                return this.$t("rules.required");
            }

            return true;
        },

        renewalRule (value) {
            if (!this.contract.tocRewal) {
                return true;
            }

            if (!value || value.length === 0) {
                return this.$t("rules.required");
            }

            if (value < 1) {
                return this.$t('contract.toc.renewal.error');
            }

            return true;
        },

        renewalTypeRule (value) {
            if (!this.contract.tocRewal) {
                return true;
            }

            if (!value) {
                return this.$t("rules.required");
            }

            return true;
        },
    }
}
</script>
